import { ResolveFn } from "@angular/router";
import { inject } from "@angular/core";
import { SaleOrderService } from "./sale-order.service";
import { TimeUtil } from "src/app/shared/services/time-util.service";
import { Observable, of, catchError, finalize } from "rxjs";
import { ISaleOrderGetDTO } from "./models";
import { LoaderService } from "src/app/shared/components/loader/loader.service";

export const saleOrderResolver: ResolveFn<
  Observable<ISaleOrderGetDTO[]>
> = () => {
  const saleOrderService = inject(SaleOrderService);
  const loaderService = inject(LoaderService);
  const timeUtil = inject(TimeUtil);
  loaderService.show();
  return saleOrderService
    .get({
      pullDate: timeUtil.formatDateLocalYYYYMMDD(new Date()),
    })
    .pipe(
      catchError(() => of([])),
      finalize(() => {
        loaderService.hide();
      })
    );
};
